import axios from '@/core/http'

const getSpiderDailyStats = spiderId => {
  return axios.get('spiders/stats/daily/', { params: { 'spider': spiderId, 'page_size': 100 } })
}

export { getSpiderDailyStats }
